import { VALoanAppPayload } from "@eave/shared/types/api/va-loans";

// This type represents the data expected by the VA Loans Page
// This type is temporary, and meant to help during initial dev
// We can keep it later if it's helpful, but remove if it's an unnecessary abstraction
export type VALoansPageData = VALoanAppPayload & {
  loan_application_id: number;
  va_loan_application_id: number;

  vesting_type: string;
  vesting_type_other_description: string;

  // General Information
  borrower1_first_name: string;
  borrower1_middle_name: string;
  borrower1_last_name: string;

  borrower1_current_address_line1: string;
  borrower1_current_address_line2: string;
  borrower1_current_city: string;
  borrower1_current_state: string;
  borrower1_current_postal_code: string;

  purchased_property_address_line1: string;
  purchased_property_address_line2: string;
  purchased_property_city: string;
  purchased_property_state: string;
  purchased_property_postal_code: string;
  has_borrower2: boolean;

  external_id: string | null;
  loan_amount: string;
  effective_rate: string;
  proposed_maturity: string;

  // VA-Loan Related Fields
  discount_amount: string;
  lender_mortgagee_id_code: string;
  sponsor_agent_id_code: string;
  lender_mortgagee_name_and_address: string;
  name_of_sponsor_agent: string;
  address_of_sponsor_agent: string;
  lender_mortgagee_telephone_number: string;

  first_time_homebuyer: boolean;
  // names_and_functions_of_agents: string;

  borrower1_is_veteran: boolean | string;
  borrower2_is_veteran: boolean | string;
  borrower1_use_va_entitlement: boolean | string;
  borrower2_use_va_entitlement: boolean | string;
  is_va_loan_application_borrower_value: boolean;
};

type vaAddressFields =
  | "borrower1_current_address_line1"
  | "borrower1_current_address_line2"
  | "borrower1_current_city"
  | "borrower1_current_state"
  | "borrower1_current_postal_code"
  | "purchased_property_address_line1"
  | "purchased_property_address_line2"
  | "purchased_property_city"
  | "purchased_property_state"
  | "purchased_property_postal_code";

type nameFields = "borrower1_first_name" | "borrower1_middle_name" | "borrower1_last_name";

type humanizedFields = vaAddressFields | nameFields;

export type VALoansPageDataDisplay = Omit<VALoansPageData, humanizedFields> & {
  borrower1_current_address: string;
  purchased_property_address: string;
  borrower1_name: string;
};

// Maps a key to a label
export type addendumFormKeyToLabel = {
  [key in keyof VALoansPageDataDisplay]: string;
};

export enum VAPageSection {
  ApplicationInfo = "Application Info",
  BorrowerInfo = "Borrower Info",
  Form1802 = "Form 1802",
  LoanInfo = "Loan Info",
  LenderSponsorAgentInfo = "Lender/Sponsor Agent Info",
}
